import React from 'react';
import Button from '../Shared/components/controls/Button';
import './style.scss';

const InputWithButton = (props) => {
  const { button, placeholder } = props;
  return (
    <div className="InputWithButton">
      <input placeholder={placeholder?.value} />
      <Button variant="contained" link={button} />
    </div>
  );
};

export default InputWithButton;
